import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCriticalInfrastructures = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.4752 2.94683C11.7037 2.53465 12.2963 2.53465 12.5248 2.94683L21.8985 19.8591C22.1202 20.259 21.831 20.75 21.3738 20.75H2.62626C2.16903 20.75 1.87982 20.259 2.10147 19.8591L11.4752 2.94683Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.6667 9L10 13H14L12.3333 17",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCriticalInfrastructures;
